import React from 'react'
import {Modal} from 'react-bootstrap-v5'
import {toAbsoluteUrl} from '../../_metronic/helpers'
import './calendar.css'
import Moment from 'moment'
import httpService from '../../setup/http/httpServices'
import { useHistory } from 'react-router-dom'

export const CampaignModal = (props: any) => {
  const history: any = useHistory();

  return (
    <Modal
      show={props.show}
      onHide={props.close}
      aria-labelledby='contained-modal-title-vcenter '
      centered
    >
      <Modal.Body className='p-0 '>
        <div className='bg-white rounded modal-card'>
          <div className='modal-card-title'>
            <img src={props.details.brandLogo} alt='' />
            <div>
              <h2>{props.details.name}</h2>
              <p>{props.details.brandName}</p>
            </div>
          </div>
          <div className='modal-card-body'>
            <div className='modal-card-bodyL'>
              <p>Platform</p>
              <p>Content Type</p>
              <p>Agency Associated</p>
              <p>Influencer Associated</p>
            </div>
            <div className='modal-card-bodyR'>
              <div>
                <img
                  src={toAbsoluteUrl('/media/logos/Instagram.png')}
                  style={{marginRight: '6px'}}
                  alt=''
                />
                Instagram
              </div>
              <div className='flex justify-content-start'>
                <div>
                  <img
                    src={toAbsoluteUrl('/media/logos/reels.png')}
                    style={{marginRight: '6px'}}
                    alt=''
                  />
                  {props.contentType}
                </div>
              </div>
              <div>
                <img
                  src={props.details.brandLogo}
                  style={{width: '24px', height: '24px', borderRadius: '60px', marginRight: '8px'}}
                  alt=''
                />
                {props.details.agencyName}
              </div>
              <div className='symbol-group symbol-hover flex-shrink-0 me-2'>
                <div className='symbol symbol-circle symbol-35px border-0'>
                  <img
                    src={toAbsoluteUrl('/media/avatars/150-1.jpg')}
                    style={{width: '24px', height: '24px'}}
                    alt=''
                  />
                </div>
                <div className='symbol symbol-circle symbol-35px border-0'>
                  <img
                    src={toAbsoluteUrl('/media/avatars/150-2.jpg')}
                    style={{width: '24px', height: '24px'}}
                    alt=''
                  />
                </div>
                <div className='symbol symbol-circle symbol-35px border-0'>
                  <img
                    src={toAbsoluteUrl('/media/avatars/150-3.jpg')}
                    style={{width: '24px', height: '24px'}}
                    alt=''
                  />
                </div>
                <div className='symbol symbol-circle symbol-35px border-0'>
                  <img
                    src={toAbsoluteUrl('/media/avatars/150-4.jpg')}
                    style={{width: '24px', height: '24px'}}
                    alt=''
                  />
                </div>
                <div className='symbol symbol-circle symbol-35px border-0'>
                  <img
                    src={toAbsoluteUrl('/media/avatars/150-5.jpg')}
                    style={{width: '24px', height: '24px'}}
                    alt=''
                  />
                </div>
                <div className='symbol symbol-circle symbol-35px border-0'>
                  <div
                    className='symbol-label fw-bolder bg-gray'
                    style={{width: '24px', height: '24px'}}
                  >
                    {props.details.noOfInfluencers}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='modal-card-footer'>
            <div>
              <p>Start Date</p>
              <h2>{Moment(props.details.startDate).format('YYYY-MM-DD')}</h2>
            </div>
            <div>
              <p>End Date</p>
              <h2>{Moment(props.details.endDate).format('YYYY-MM-DD')}</h2>
            </div>
            <div>
              <p>Live Date</p>
              <h2>{Moment(props.details.liveDate).format('YYYY-MM-DD')}</h2>
            </div>
          </div>
          <button className='btn btn-primary d-flex flex h-34px fs-7' onClick={() => {
                httpService.getData("/campaign-master/" + props.details.campaignId, (response: any) => {
                  response.data.data.campaign.campaignStatus = response.data.data.campaign.status;
                  history.push({
                    pathname: '/campaign/campaignDetailById',
                    state: {
                      ...response.data.data.campaign,
                      _id: props.details.campaignId,
                      ...{ type: response.data.data.campaign.campaignDetails.name, breadcrums: ["Campaigns", "Campaign Overview"] }
                    }
                  })
                }, (error: any) => {
            
                })
          }}>View Details</button>
        </div>
      </Modal.Body>
    </Modal>
  )
}
